
import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { 
  DropdownMenu, 
  DropdownMenuContent, 
  DropdownMenuItem, 
  DropdownMenuTrigger,
  DropdownMenuSeparator
} from "@/components/ui/dropdown-menu";
import { ChevronDown } from "lucide-react";
import { mainNavItems, adminNavItems, getUserProfileUrl } from "@/config/navigation";

interface DesktopNavProps {
  isHomePage: boolean;
}

const DesktopNav = ({ isHomePage }: DesktopNavProps) => {
  const { user, isAdmin } = useAuth();
  const location = useLocation();
  const [isMounted, setIsMounted] = useState(false);
  
  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) return null;

  return (
    <div className="flex items-center space-x-6">
      {/* Main Navigation - exclude Home link if on homepage */}
      {mainNavItems
        .filter(item => !isHomePage || item.href !== "/")
        .filter(item => !item.requiresAuth || user)
        .map(item => (
          <Link
            key={item.href}
            to={item.href}
            className={`text-sm font-medium transition-colors hover:text-foreground/80 ${
              location.pathname === item.href 
                ? "text-foreground" 
                : "text-foreground/60"
            }`}
          >
            <span className="hidden md:inline">{item.title}</span>
            {item.icon && <item.icon className="w-4 h-4 md:hidden" />}
          </Link>
        ))}

      {/* Admin Dropdown (only for admins) */}
      {isAdmin && (
        <DropdownMenu>
          <DropdownMenuTrigger className="text-sm font-medium transition-colors hover:text-foreground/80 text-foreground/60 flex items-center">
            <span className="hidden md:inline">Admin</span>
            <ChevronDown className="w-4 h-4 ml-1" />
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            {adminNavItems.map(item => (
              <DropdownMenuItem key={item.href} asChild>
                <Link to={item.href} className="flex items-center">
                  {item.icon && <item.icon className="w-4 h-4 mr-2" />}
                  {item.title}
                </Link>
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      )}
    </div>
  );
};

export default DesktopNav;
